<template>
  <div class="sportscareer"></div>
</template>

<script>
export default {
  name: "SportsCareer",

  beforeCreate() {
    window.location.href =
      "https://www.amtamassage.org/find-massage-school/"
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SportsCareer.vue